import config from "./config.js";

$(document).ready(function () {
	$("#subscribeForm").on("submit", function (e) {
		e.preventDefault();

		const form = $(this);
		const btn = form.find(".btn-subscribe");
		const originalText = btn.text();

		// Validate
		let valid = true;
		form.find("[required]").each(function () {
			if (!this.value.trim()) {
				valid = false;
				$(this).addClass("is-invalid");
			} else {
				$(this).removeClass("is-invalid");
			}
		});

		if (!valid) return;

		btn.prop("disabled", true).text("Đang gửi...");

		$.post(
			config.ajaxurl,
			form.serialize() + "&action=subscribe_course",
			function (res) {
				btn.prop("disabled", false).text(originalText);
				if (res.alert && typeof res.alert === "object") {
					$("#messageDialogTitle").html(res.alert.title || "");
					$("#messageDialogBody").html(res.alert.body || "");
				}
				$("#messageDialog").modal("show");

				if (!res.error) {
					form[0].reset();
				}
			},
			"json"
		).fail(function () {
			btn.prop("disabled", false).text(originalText);
		});
	});

	$("#subscribeForm [required]").on("input", function () {
		$(this).removeClass("is-invalid");
	});
});
